import { Component, Input, Renderer, EventEmitter, Output, AfterViewChecked, OnInit, ChangeDetectorRef, ViewChild, Renderer2 } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ControlService } from '@app/base/service/control.service';
import { select } from '@ngrx/store';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
    selector: 'app-eclesial-select',
    templateUrl: './eclesial.select.component.html',
})

export class EclesialSelectComponent implements AfterViewChecked, OnInit {

    ngOnInit(): void {
        this.labelColSize = this.labelColSize;
        this.inputColSize = this.inputColSize;
    }
    ngAfterViewChecked(): void {
        let element: any = document.getElementById(this.controlName);

        if (element === undefined || this.place === undefined) {
            element.placeholder = '';
        } else {
            element.placeholder = this.place;
        }

        this.cdr.detectChanges();
    }

    @Input() formGroup: FormGroup;
    @Input() options: Object[];
    @Input() labelDescription: string;
    @Input() value: string;
    @Input() description: string;
    @Input() controlName: string;
    @Input() groupName: string;
    @Input() trySave: boolean;
    @Input() place: string;

    @Input() showLabel: boolean = true;
    @Input() isSelectSearch: boolean = false;
    @Input() isInactive: boolean = false;

    @Input() labelColSize: string = 'col-6';
    @Input() inputColSize: string = 'col-6';

    @Input() lastControlFocus: string;

    @Output() lastFocusControlChange: EventEmitter<string> = new EventEmitter();
    @Output() nextFocus: EventEmitter<any> = new EventEmitter();

    public hasFocus: boolean;

    constructor(
        private cdr: ChangeDetectorRef,
        private controlService: ControlService,
    ) {
    }

    onFocus() {
        this.hasFocus = true;
        this.lastFocusControlChange.emit(this.controlName);
    }

    onFocusOut() {
        this.hasFocus = false;
    }

    getValue(option) {
        return option[this.value];
    }

    getDescription(option) {
        return option[this.description];
    }

    onSelectOptionChange() {
        this.nextFocus.emit();
    }

    onKeyDownEnter(event) {
        event.preventDefault();
    }
}
